import { useEffect, useRef } from 'react';

export const hasUnsavedQuoteChanges = (editor) => Boolean(editor
  && (editor.serverCalculationStatus === 'stale' || editor.serverWriteConflict));

export default function useQuoteEditorNavigation({ editor, setEditor, setError, pendingComposition = false }) {
  const current = useRef(editor);
  const pending = useRef(pendingComposition); pending.current = pendingComposition;
  current.current = editor;
  const sequence = useRef(0);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; sequence.current += 1; };
  }, []);
  useEffect(() => {
    const preventLoss = (event) => {
      if (!hasUnsavedQuoteChanges(current.current) && !pending.current) return;
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', preventLoss);
    return () => window.removeEventListener('beforeunload', preventLoss);
  }, []);
  return {
    begin() {
      if ((hasUnsavedQuoteChanges(current.current) || pending.current)
        && !window.confirm('Des modifications ne sont pas enregistrées. Quitter cet éditeur et les abandonner ?')) return null;
      return { sequence: ++sequence.current, editor: current.current };
    },
    apply(ticket, next) {
      if (!mounted.current || ticket.sequence !== sequence.current) return false;
      if (current.current !== ticket.editor) {
        setError('Vos nouvelles saisies ont été conservées. Confirmez à nouveau le changement pour les abandonner.');
        return false;
      }
      setEditor((value) => value === ticket.editor ? next : value);
      return true;
    },
    current(ticket) { return mounted.current && ticket.sequence === sequence.current && current.current === ticket.editor; },
  };
}
